{
    "(save {highestYearlyDiscount}%)": "({highestYearlyDiscount}% 절약)",
    "{amount} days free": "{amount}일 무료",
    "{amount} off": "{amount} 할인",
    "{amount} off for first {number} months.": "첫 {number}개월 {amount} 할인.",
    "{amount} off for first {period}.": "첫 {period} {amount} 할인.",
    "{amount} off forever.": "{amount} 영원히 할인.",
    "{discount}% discount": "{discount}% 할인",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail}님은 {newsletterName} 뉴스레터를 더 이상 받지 않으실 거예요.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail}님은 다른 사람이 댓글에 답글을 남겨도 더 이상 이메일을 받지 않으실 거예요.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail}님은 이 뉴스레터를 더 이상 받지 않으실 거예요.",
    "{memberEmail} will no longer receive updates & announcements.": "{memberEmail}님은 업데이트 및 공지사항을 더 이상 받지 않으실 거예요.",
    "{months} months": "{months}개월",
    "{months} months free": "{months}개월 무료",
    "{tierName} membership": "{tierName} 멤버십",
    "{trialDays} days free": "{trialDays}일 무료",
    "{years} years": "{years}년",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "1개월",
    "1 month free": "1개월 무료",
    "1 year": "1년",
    "A gift, just for you": "당신만을 위한 선물",
    "Access your RSS feeds": "RSS 피드 이용하기",
    "Account": "계정",
    "Account details updated successfully": "계정 정보가 성공적으로 업데이트되었어요",
    "Account settings": "계정 설정",
    "Add a personal note": "개인 메모 추가",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "무료 체험이 종료되면 선택한 요금제의 정상 가격이 청구돼요. 그 전에 언제든지 취소할 수 있어요.",
    "Already a member?": "이미 회원이신가요?",
    "An error occurred": "오류가 발생했어요",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "예기치 않은 오류가 발생했어요. 계속해서 오류가 발생하면 다시 시도하거나 <a>지원팀에 문의</a>해 주세요.",
    "Back": "뒤로",
    "Back to Log in": "로그인으로 돌아가기",
    "Before you go": "떠나기 전에",
    "Billing info & receipts": "결제 정보 및 영수증",
    "Black Friday": "블랙 프라이데이",
    "Bluesky": "Bluesky",
    "Cancel anytime.": "언제든지 취소할 수 있어요.",
    "Cancel subscription": "구독 취소",
    "Canceled": "취소됨",
    "Cancellation reason": "취소 사유",
    "Change": "변경",
    "Change plan": "요금제 변경",
    "Check spam & promotions folders": "스팸 & 프로모션 폴더를 확인해 주세요",
    "Check with your mail provider": "메일 제공업체에 문의해 주세요",
    "Check your inbox to verify email update": "이메일 업데이트를 확인하기 위해 받은 편지함을 확인해 주세요",
    "Choose": "선택",
    "Choose a different plan": "다른 요금제 선택",
    "Choose a plan": "요금제 선택",
    "Choose your newsletters": "뉴스레터 선택",
    "Click here to retry": "다시 시도하려면 여기를 클릭해 주세요",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "멤버십 사용을 완료하려면 받은 편지함의 확인 링크를 클릭해 주세요. 3분 이내에 도착하지 않으면 스팸 폴더를 확인해 주세요.",
    "Close": "닫기",
    "Code": "코드",
    "Comment preferences updated.": "댓글 설정이 업데이트되었어요.",
    "Comments": "댓글",
    "Complimentary": "무료",
    "Confirm": "확인",
    "Confirm cancellation": "취소 확인",
    "Confirm subscription": "구독 확인",
    "Contact support": "지원팀에 문의",
    "Continue": "계속",
    "Continue subscription": "구독 계속",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "언제든지 유료 구독으로 전환할 수 있어요. 남은 선물 기간은 무료 체험으로 추가돼요.",
    "Copied": "복사됨",
    "Copy": "복사",
    "Copy link": "링크 복사",
    "Could not create Stripe billing portal session": "Stripe 결제 포털 세션을 생성할 수 없었어요",
    "Could not create Stripe checkout session": "Stripe 결제 세션을 생성할 수 없었어요",
    "Could not sign in. Login link expired.": "로그인할 수 없어요. 로그인 링크가 만료되었어요.",
    "Could not update email! Invalid link.": "이메일을 업데이트할 수 없어요! 잘못된 링크이에요.",
    "Create a new contact": "새 연락처 만들기",
    "Current plan": "현재 요금제",
    "Delete account": "계정 삭제",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "의도치 않았나요? 기본 설정을 <button>여기</button>에서 관리할 수 있어요.",
    "Don't have an account?": "계정이 없으신가요?",
    "Edit": "편집",
    "Email": "이메일",
    "Email confirmation link expired.": "이메일 확인 링크가 만료되었어요.",
    "Email newsletter": "이메일 뉴스레터",
    "Email newsletter settings updated": "이메일 뉴스레터 설정이 업데이트되었어요",
    "Email preferences": "이메일 설정",
    "Email preferences updated.": "이메일 설정이 업데이트되었어요.",
    "Emails": "이메일",
    "Emails disabled": "이메일 사용 중지됨",
    "Ends {offerEndDate}": "{offerEndDate}에 종료돼요",
    "Enjoy {amountOff} off forever.": "{amountOff} 할인을 평생 누려보세요.",
    "Enjoy {months} free months on us.": "{months}개월을 무료로 즐겨보세요.",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "{months}개월을 무료로 즐겨보세요. {newBillingDate}까지는 요금이 청구되지 않아요.",
    "Enjoy a free month on us.": "한 달을 무료로 즐겨보세요.",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "한 달을 무료로 즐겨보세요. {newBillingDate}까지는 요금이 청구되지 않아요.",
    "Enter code above": "위에 코드를 입력해 주세요",
    "Enter your email address": "이메일 주소를 입력해 주세요",
    "Enter your name": "이름을 입력해 주세요",
    "Error": "오류",
    "Expires {expiryDate}": "{expiryDate}에 만료돼요",
    "Facebook": "Facebook",
    "Failed to cancel subscription, please try again": "구독 취소에 실패했어요. 다시 시도해 주세요",
    "Failed to log in, please try again": "로그인에 실패했어요. 다시 시도해 주세요",
    "Failed to log out, please try again": "로그아웃에 실패했어요. 다시 시도해 주세요",
    "Failed to open billing portal, please try again": "결제 포털을 여는 데 실패했어요. 다시 시도해 주세요",
    "Failed to process checkout, please try again": "결제 처리에 실패했어요. 다시 시도해 주세요",
    "Failed to send magic link email": "로그인 링크 이메일 전송에 실패했어요",
    "Failed to send verification email": "인증 이메일 전송에 실패했어요",
    "Failed to sign up, please try again": "가입에 실패했어요. 다시 시도해 주세요",
    "Failed to update account data": "계정 데이터 업데이트에 실패했어요",
    "Failed to update account details": "계정 상세정보 업데이트에 실패했어요",
    "Failed to update billing information, please try again": "결제 정보 업데이트에 실패했어요. 다시 시도해 주세요",
    "Failed to update newsletter settings": "뉴스레터 설정 업데이트에 실패했어요",
    "Failed to update subscription, please try again": "구독 업데이트에 실패했어요. 다시 시도해 주세요",
    "Failed to verify code, please try again": "코드 확인에 실패했어요. 다시 시도해 주세요",
    "Forever": "영원히",
    "Free Trial – Ends {trialEnd}": "무료 체험 – {trialEnd}에 종료돼요",
    "Get help": "도움 요청",
    "Get in touch for help": "도움말을 받으려면 연락해 주세요",
    "Get notified when someone replies to your comment": "댓글에 대한 답변이 올라오면 알림 받기",
    "Gift a membership": "멤버십 선물하기",
    "Gift could not be redeemed": "선물을 사용할 수 없었어요",
    "Gift details": "선물 상세정보",
    "Gift redeemed! You're all set.": "선물을 사용했어요! 모든 준비가 끝났어요.",
    "Gift subscription": "구독 선물하기",
    "Gift subscriptions are not available right now.": "지금은 구독 선물을 이용할 수 없어요.",
    "Gift value": "선물 금액",
    "Give feedback on this post": "이 게시물에 대한 의견 말하기",
    "Help! I'm not receiving emails": "도와주세요! 이메일을 받지 못하고 있어요",
    "Here are a few other sites you may enjoy.": "회원님이 좋아하실 만한 다른 사이트들이에요.",
    "Hide details": "상세정보 숨기기",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "만약 뉴스레터가 스팸으로 표시되면, 더 이상 원하지 않는 메시지를 받지 않도록 해당 주소의 이메일이 자동으로 사용 중지돼요.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "스팸 신고가 실수였거나 이메일을 다시 받기를 원하면, 이전 화면의 버튼을 클릭하여 이메일을 다시 구독할 수 있어요.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "지금 구독을 취소하시면 {periodEnd}까지는 계속 이용하실 수 있어요.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "만약 회사나 정부 이메일 계정을 사용하고 있다면, IT 부서에 연락하여 {senderEmail}에서 이메일을 받을 수 있도록 요청해 주세요",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "로그인 링크가 이메일로 전송되었어요. 3분 내에 도착하지 않으면 스팸 폴더를 확인해 주세요.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "계정이 있다면 {submittedEmailOrInbox}(으)로 이메일을 보냈어요. 이메일 안의 링크를 클릭하거나 아래에 코드를 입력해 주세요.",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "이메일을 다시 받기를 원한다면, 가장 좋은 방법은 문제가 있는지 확인한 다음 이전 화면의 다시 구독 버튼을 클릭하는 것이에요.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "만약 구독한 이메일 뉴스레터를 받지 못하고 있다면, 확인해야 할 몇 가지 사항이 있어요.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "이 모든 확인을 완료했는데도 이메일을 받지 못하고 있다면, {supportAddress}에 연락하여 지원을 받을 수 있어요.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "영구적인 실패가 발생하여 뉴스레터를 보내려고 시도할 때, 계정의 이메일이 사용 중지돼요.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "이메일 클라이언트에서 {senderEmail}을 연락처 목록에 추가해 주세요. 이렇게 하면 메일 제공업체에게 이 주소에서 보낸 이메일을 신뢰해야 한다는 신호를 보낼 수 있어요.",
    "Invalid email address": "잘못된 이메일 주소예요",
    "Invalid verification code": "잘못된 인증 코드예요",
    "Jamie Larson": "홍길동",
    "jamie@example.com": "gildong@example.com",
    "Less like this": "비슷한 게시물 줄이기",
    "LinkedIn": "LinkedIn",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "이메일이 스팸이나 프로모션 폴더에 실수로 들어가지 않도록 해 주세요. 만약 들어가 있다면 \"스팸이 아님\" 또는 \"받은 편지함으로 이동\"을 클릭해 주세요.",
    "Manage": "관리",
    "Maybe later": "나중에 하기",
    "Membership details": "멤버십 상세정보",
    "Memberships from this email domain are currently restricted.": "현재 이 이메일 도메인에서의 멤버십 가입이 제한되어 있어요.",
    "Memberships unavailable, contact the owner for access.": "멤버십을 이용할 수 없어요. 접근 권한을 위해 관리자에게 문의해 주세요.",
    "month": "월",
    "Monthly": "월간",
    "More like this": "비슷한 게시물 더 보기",
    "More options": "더 많은 옵션",
    "Name": "이름",
    "Need more help? Contact support": "더 많은 도움이 필요하신가요? 지원팀에 문의해 주세요",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "뉴스레터는 계정에서 두 가지 이유로 사용 중지될 수 있어요: 이전 이메일이 스팸으로 표시되었거나, 이메일을 보내려고 시도했지만 영구적인 실패가 발생했을 때(바운스).",
    "No member exists with this e-mail address.": "이 이메일 주소로 등록된 회원이 없어요.",
    "No thanks, I want to cancel": "아니요, 취소할게요",
    "Not ready to share? We've also emailed a copy to your inbox.": "아직 공유할 준비가 안 되셨나요? 받은 편지함에도 사본을 보내드렸어요.",
    "Not receiving emails?": "이메일을 받지 못하고 계신가요?",
    "Now check your email!": "지금 이메일을 확인해 주세요!",
    "Occasional updates from {siteTitle}": "{siteTitle}에서 가끔 전하는 소식",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "다시 구독한 후에도 받은 편지함에 이메일이 표시되지 않는다면 스팸 폴더를 확인해 주세요. 일부 받은 편지함 제공업체는 이전 스팸 신고 기록을 유지하고 계속해서 이메일을 표시해요. 이런 경우 최신 뉴스레터를 '스팸이 아님'으로 표시하여 기본 받은 편지함으로 옮겨주세요.",
    "Open AOL Mail": "AOL Mail 열기",
    "Open email": "이메일 열기",
    "Open Feedbin": "Feedbin 열기",
    "Open Gmail": "Gmail 열기",
    "Open Hey": "Hey 열기",
    "Open iCloud Mail": "iCloud Mail 열기",
    "Open Mail.ru": "Mail.ru 열기",
    "Open Outlook": "Outlook 열기",
    "Open Proton Mail": "Proton Mail 열기",
    "Open Yahoo Mail": "Yahoo Mail 열기",
    "Permanent failure (bounce)": "영구적인 실패(바운스)",
    "Phone number": "전화번호",
    "Plan": "플랜",
    "Plan checkout was cancelled.": "플랜 결제가 취소되었어요.",
    "Plan upgrade was cancelled.": "플랜 업그레이드가 취소되었어요.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "무료 구독 조정을 위해 {supportAddress}로 문의해 주세요.",
    "Please enter {fieldName}": "{fieldName}을(를) 입력해 주세요",
    "Please fill in required fields": "필수 항목을 입력해 주세요",
    "Podcasts": "팟캐스트",
    "Re-enable emails": "이메일 재활성화",
    "Recommendations": "추천",
    "Redeem your membership": "멤버십 사용하기",
    "Redeeming...": "사용 중...",
    "Renews at {price}.": "{price}에 갱신돼요.",
    "Resume subscription": "구독 재개",
    "Retry": "다시 시도",
    "Save": "저장",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "다음 {durationInMonths}번의 결제 주기 동안 {amountOff}을(를) 절약하세요. 이후에는 {cadence}당 {currency}{originalPrice}이에요.",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "다음 결제 주기에 {amountOff}을(를) 절약하세요. 이후에는 {cadence}당 {currency}{originalPrice}이에요.",
    "Send the link below to share it with whoever you'd like.": "아래 링크를 보내 원하는 분과 공유하세요.",
    "Sending login link...": "로그인 링크 전송 중...",
    "Sending...": "전송 중...",
    "Share": "공유",
    "Share a full membership to {siteTitle} with a friend or colleague": "{siteTitle}의 정식 멤버십을 친구나 동료와 공유하세요",
    "Show all": "모두 보기",
    "Sign in": "로그인",
    "Sign out": "로그아웃",
    "Sign up": "가입",
    "Signup error: Invalid link": "가입 오류: 잘못된 링크",
    "Signups from this email domain are currently restricted.": "현재 이 이메일 도메인에서의 가입이 제한되어 있어요.",
    "Something went wrong, please try again later.": "문제가 발생했어요. 나중에 다시 시도해 주세요.",
    "Sorry, no paid plans are available.": "죄송해요. 이용 가능한 유료 요금제가 없어요.",
    "Sorry, no recommendations are available right now.": "죄송해요. 현재 추천할 만한 콘텐츠가 없어요.",
    "Sorry, that didn’t work.": "죄송해요. 작동하지 않았어요.",
    "Spam complaints": "스팸 신고",
    "Start {amount}-day free trial": "{amount}일 동안의 무료 체험 시작",
    "Starting {startDate}": "{startDate}부터 시작",
    "Starting today": "오늘부터 시작",
    "Submit feedback": "의견 제출",
    "Subscribe": "구독",
    "Subscribed": "구독 완료",
    "Subscription plan updated successfully": "구독 플랜이 성공적으로 업데이트되었어요",
    "Success": "성공",
    "Success! Check your email for magic link to sign-in.": "성공! 로그인을 위한 링크가 이메일로 전송되었어요.",
    "Success! Your account is fully activated, you now have access to all content.": "성공! 계정이 활성화되었어요. 이제 모든 콘텐츠에 접근할 수 있어요.",
    "Success! Your email is updated.": "성공! 이메일이 업데이트되었어요.",
    "Successfully unsubscribed": "구독이 성공적으로 취소되었어요",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "구독해 주셔서 감사해요. 읽기를 시작하기 전에, 아래에 회원님이 좋아하실 만한 다른 사이트들이 있어요.",
    "Thank you for your support": "지원해 주셔서 감사해요",
    "Thank you for your support!": "지원해 주셔서 감사해요!",
    "Thanks for the feedback!": "의견을 보내주셔서 감사해요!",
    "That didn't go to plan": "계획대로 진행되지 않았어요",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "회원님의 이메일 주소는 {memberEmail}이에요. 이 주소가 맞지 않다면 <button>계정 설정 영역</button>에서 업데이트할 수 있어요.",
    "There was a problem submitting your feedback. Please try again a little later.": "의견을 제출하는 중에 문제가 발생했어요. 잠시 후 다시 시도해 주세요.",
    "There was an error cancelling your subscription, please try again.": "구독 취소 중 오류가 발생했어요. 다시 시도해 주세요.",
    "There was an error continuing your subscription, please try again.": "구독 계속하기 중 오류가 발생했어요. 다시 시도해 주세요.",
    "There was an error processing your payment. Please try again.": "결제 처리 중 오류가 발생했어요. 다시 시도해 주세요.",
    "There was an error sending the email, please try again": "이메일 전송 중 오류가 발생했어요. 다시 시도해 주세요",
    "This gift has already been consumed.": "이 선물은 이미 소진되었어요.",
    "This gift has already been redeemed.": "이 선물은 이미 사용되었어요.",
    "This gift has been refunded.": "이 선물은 환불되었어요.",
    "This gift has expired.": "이 선물은 만료되었어요.",
    "This site is invite-only, contact the owner for access.": "위 사이트는 초대된 사용자만 사용이 가능해요. 접근을 위해서는 관리자에게 연락해 주세요.",
    "This site is not accepting donations at the moment.": "현재 이 사이트는 후원을 받지 않고 있어요.",
    "This site is not accepting payments at the moment.": "현재 이 사이트는 결제를 받지 않고 있어요.",
    "This site only accepts paid members.": "이 사이트는 유료 회원만 받고 있어요.",
    "Threads": "Threads",
    "Tier": "등급",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "가입을 완료하려면 이메일의 확인 링크를 클릭해 주세요. 3분 이내에 도착하지 않으면 스팸 폴더를 확인해 주세요!",
    "To continue to stay up to date, subscribe to {publication} below.": "계속해서 최신 소식을 받아보시려면 아래에서 {publication}을(를) 구독해 주세요.",
    "Too many attempts try again in {number} days.": "너무 많은 시도를 하셨어요. {number}일 후에 다시 시도해 주세요.",
    "Too many attempts try again in {number} hours.": "너무 많은 시도를 하셨어요. {number}시간 후에 다시 시도해 주세요.",
    "Too many attempts try again in {number} minutes.": "너무 많은 시도를 하셨어요. {number}분 후에 다시 시도해 주세요.",
    "Too many different sign-in attempts, try again in {number} days": "너무 많은 로그인 시도를 하셨어요. {number}일 후에 다시 시도해 주세요",
    "Too many different sign-in attempts, try again in {number} hours": "너무 많은 로그인 시도를 하셨어요. {number}시간 후에 다시 시도해 주세요",
    "Too many different sign-in attempts, try again in {number} minutes": "너무 많은 로그인 시도를 하셨어요. {number}분 후에 다시 시도해 주세요",
    "Too many sign-up attempts, try again later": "너무 많은 가입 시도를 하셨어요. 나중에 다시 시도해 주세요",
    "Try free for {amount} days, then {originalPrice}.": "{amount}일 동안 무료로 사용한 후 {originalPrice}로 결제해 주세요.",
    "Unable to initiate checkout session": "결제 세션을 시작할 수 없어요",
    "Unlock access to all newsletters by becoming a paid subscriber.": "유료 구독자가 되어 모든 뉴스레터에 접근해 주세요.",
    "Unsubscribe from all emails": "모든 이메일 구독 취소",
    "Unsubscribed": "구독 취소 완료",
    "Unsubscribed from all emails.": "모든 이메일 구독이 취소되었어요.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "이메일 구독 취소는 {title}에 대한 유료 구독을 취소하지 않아요",
    "Update": "업데이트",
    "Update your preferences": "설정 업데이트",
    "Updates & announcements": "업데이트 및 공지사항",
    "Verification link sent, check your inbox": "인증 링크를 보냈어요. 받은 편지함을 확인해 주세요",
    "Verify your email address is correct": "이메일 주소가 올바른지 확인해 주세요",
    "Verifying...": "확인 중...",
    "View plans": "플랜 보기",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "이메일 주소를 찾을 수 없어 구독을 취소할 수 없어요. 사이트 관리자에게 문의해 주세요.",
    "We'd hate to see you leave. How about a special offer to stay?": "떠나신다니 아쉬워요. 계속 함께하실 수 있도록 특별 혜택은 어떠세요?",
    "Welcome back, {name}!": "{name}님, 다시 돌아오신 것을 환영해요!",
    "Welcome back!": "다시 돌아오신 것을 환영해요!",
    "Welcome to {siteTitle}": "{siteTitle}에 오신 것을 환영해요",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "받는 편지함이 이메일을 받지 못하는 경우 이를 바운스(bounce)라고 해요. 이는 일시적인 경우가 많지만, 이메일 주소가 잘못되었거나 존재하지 않는 경우 영구적인 실패로 반환될 수도 있어요.",
    "Why has my email been disabled?": "왜 이메일이 비활성화되었나요?",
    "X (Twitter)": "X (Twitter)",
    "year": "년",
    "Yearly": "연간",
    "You already have an active subscription.": "이미 활성화된 구독이 있어요.",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "현재 무료 멤버십을 사용 중이에요. 유료 구독으로 업그레이드하면 모든 콘텐츠에 접근하실 수 있어요.",
    "You have been successfully resubscribed": "성공적으로 재구독되었어요",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "이제 {expiryDate}까지 {tierName}을(를) 이용하실 수 있어요. 즐겨주세요!",
    "You're currently not receiving emails": "현재 이메일을 받지 않고 계세요",
    "You're not receiving emails": "이메일을 받지 않고 계세요",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "최근 메시지를 스팸으로 표시했거나 메시지를 제공된 이메일 주소로 전달할 수 없어 이메일을 받지 못하고 계세요.",
    "You've been gifted a membership": "멤버십을 선물받으셨어요",
    "You've been gifted a membership to {siteTitle}": "{siteTitle}의 멤버십을 선물받으셨어요",
    "You've successfully signed in.": "성공적으로 로그인되었어요.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "성공적으로 구독하셨어요: <strong>{siteTitle}</strong>",
    "Your account": "계정",
    "Your email": "이메일",
    "Your email has failed to resubscribe, please try again": "이메일 재구독에 실패했어요. 다시 시도해 주세요",
    "Your gift is ready": "선물이 준비됐어요",
    "Your gift subscription will expire on {expiryDate}": "선물 구독이 {expiryDate}에 만료돼요",
    "your inbox": "받은 편지함",
    "Your input helps shape what gets published.": "회원님의 의견은 게시물을 제작하는 것에 큰 도움이 돼요.",
    "Your name": "이름",
    "Your subscription has been canceled and will expire on {expiryDate}.": "구독이 취소되었으며 {expiryDate}에 만료돼요.",
    "Your subscription will expire on {expiryDate}": "회원님의 구독은 {expiryDate}에 만료돼요",
    "Your subscription will renew on {renewalDate}": "회원님의 구독은 {renewalDate}에 갱신돼요",
    "Your subscription will start on {subscriptionStart}": "회원님의 구독은 {subscriptionStart}에 시작돼요"
}
